import React, { useEffect, useState } from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import AdmarktRegistrationSteps from './components/AdmarktRegistrationSteps';
import admarktTabs from '../../constants/admarktTabs';
import { AppState, EnvironmentConfig } from '../../../../../types/AppState';

const AdmarktRegistration = ({ appState, environment }: { appState: AppState; environment: EnvironmentConfig }) => {
  const { showLoginDialog, loggedInUser, switchUserUrl, redirectTo2FA } = appState;
  const [initialActiveTabId, setInitialActiveTabId] = useState('');

  useEffect(() => {
    setInitialActiveTabId(window.location.hash.substring(1) || admarktTabs[0].id);
  }, []);

  return (
    <EnvironmentProvider value={environment}>
      <AdmarktRegistrationSteps
        initialActiveTabId={initialActiveTabId}
        showLoginDialogOnLoad={showLoginDialog}
        loggedInUser={loggedInUser}
        switchUserUrl={switchUserUrl}
        redirectTo2FA={redirectTo2FA}
      />
    </EnvironmentProvider>
  );
};

export default AdmarktRegistration;
